import { ConversationsAction, ConversationsActionType, LoadConversationsFailedAction, LoadConversationsSucceededAction } from './conversations.actions';
import { ConversationsState, CONVERSATIONS_INIT_STATE } from './conversations.state';

export function conversationsReducer(state: ConversationsState = CONVERSATIONS_INIT_STATE, action: ConversationsAction): ConversationsState {
    switch (action.type) {
        case ConversationsActionType.LOAD_CONVERSATIONS: {
            return { 
                ...state, 
                isReady         : false,
                conversations   : null, 
                error           : null
            };
        }
        case ConversationsActionType.LOAD_CONVERSATIONS_FAILED: {
            return { 
                ...state, 
                isReady         : true,
                conversations   : null, 
                error           : (<LoadConversationsFailedAction>action.error)
            };
        }
        case ConversationsActionType.LOAD_CONVERSATIONS_SUCCEEDED: {
            return { 
                ...state, 
                isReady         : true,
                conversations   : (<LoadConversationsSucceededAction>action).conversations, 
                error           : null
            };
        }
        default:
            return state;
    }
}
